export default __webpack_public_path__ + "static/media/03.04a5ca5a.jpg";